const observer = new MutationObserver(() => {
  const el = document.querySelector('.current-customer-name');
  if (el && !el.dataset.sanAppended) {
    const text = el.textContent.trim();
    const parts = text.split(' ');
    if (parts.length === 2 && !parts[1].endsWith('さん')) {
      el.textContent = `${parts[0]} ${parts[1]}さん`;
      el.dataset.sanAppended = "true";
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
